import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
import { Search } from '@element-plus/icons-vue';
import { onMounted, reactive, ref, watch } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
import _ from 'lodash';
import { getExistContractInfo } from "@/api/modules/advert";
import { getChildrenListByRoleId, getRolesUserList } from "@/api/modules/system";
export default {
  __name: 'AdvertLaunchAdd',
  props: {
    title: {
      type: String,
      default: '新增投放',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    roleId: {
      type: String,
      default: ''
    }
  },
  emits: ['success', 'update:visible'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const data = reactive({
      form: {},
      roleId: '',
      //登陆人所在公司所属角色ID
      // 供应商列表
      childrenList: [],
      // 供应商对应的处理人列表
      checkUserList: new Map()
    });
    const elLoading = ref(false);
    const handleQueryContract = () => {
      if (!data.form.contractCode) {
        ElMessage.error('请先输入已创建管理的合同编码!');
        return;
      }
      elLoading.value = true;
      apis.getExistContractInfo({
        code: data.form.contractCode
      }).then(res => {
        console.log("contract", res.data);
        if (res.success) {
          if (props.roleId.substr(props.roleId.indexOf('0')) !== res.data.contractInfo.areaCode) {
            ElMessage.error("该合同非当前账户管辖区域");
            return;
          }
          data.form.contractName = res.data.contractInfo.contractName;
          data.form.contractCode = res.data.contractInfo.contractCode;
          //以下无需展示仅保存时传递
          data.form.contractId = res.data.contractInfo.id;
          data.form.areaCode = res.data.contractInfo.areaCode;
        } else {
          ElMessage.error("未查到合同信息,请先在广告结算管理菜单中创建合同!");
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const init = () => {
      data.childrenList = [];
      data.opCompany = [];
      apis.getChildrenListByRoleId(props.roleId).then(res => {
        if (res.success) {
          data.childrenList = res.data;
        }
      });
    };
    const selectCompany = items => {
      for (const item of items) {
        if (data.checkUserList.has(item.id)) {
          continue;
        }
        apis.getRolesUserList(item.roleId).then(res => {
          if (res.success) {
            data.checkUserList.set(item.id, res.data);
          }
        });
      }
    };
    const close = () => {
      data.form = {};
      emits('update:visible', false);
    };
    const handleSave = () => {
      if (!data.form.contractCode) {
        ElMessage.error("请输入合同编号");
        return;
      }
      if (!data.form.contractName) {
        ElMessage.error("合同名称为空!");
        return;
      }
      if (!data.form.taskName) {
        ElMessage.error("任务名称不能为空!");
        return;
      }
      if (!data.form.opCompany || data.form.opCompany.length === 0) {
        ElMessage.error("请选择供应商!");
        return;
      }
      for (const company of data.form.opCompany) {
        if (!company.checkUser || company.checkUser.length === 0) {
          ElMessage.error("请选择执行人员!");
          return;
        }
      }
      let param = Object.assign(data.form);
      console.log("add advert launch", param);
      elLoading.value = true;
      apis.addAdvertLaunchInfo(param).then(res => {
        if (res.success) {
          emits("success");
          ElMessage.success("添加成功！");
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
        close();
      });
    };
    watch(() => props.roleId, (newvalue, oldvalue) => {
      data.roleId = newvalue;
    }, {
      deep: false,
      immediate: true
    });
    onMounted(() => {});
    __expose({
      init
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "50%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSave
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("保存", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          model: data.form,
          "label-width": "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "合同编码",
            prop: "contractCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.contractCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.form.contractCode = $event),
              placeholder: "请输入合同编码"
            }, {
              append: _withCtx(() => [_createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: handleQueryContract
              }, null, 8, ["icon"])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同名称",
            prop: "contractName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.contractName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.form.contractName = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "任务名称",
            prop: "taskName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.form.taskName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.form.taskName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "执行公司",
            prop: "opCompany"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: data.form.opCompany,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.form.opCompany = $event),
              multiple: "",
              "value-key": "id",
              onChange: selectCompany
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.childrenList, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.roleName,
                  value: item
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.form.opCompany, (item, index) => {
            return _openBlock(), _createBlock(_component_el_form_item, {
              key: index,
              label: `${item.roleName}`
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: item.checkUser,
                "onUpdate:modelValue": $event => item.checkUser = $event,
                multiple: "",
                "value-key": "id",
                placeholder: "请选择执行人员"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.checkUserList.get(item.id), (subItem, subIndex) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: subIndex,
                    label: subItem.name,
                    value: subItem
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, elLoading.value]])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};